import { render, staticRenderFns } from "./ChatProjectDetailView.vue?vue&type=template&id=ff31c408&scoped=true"
import script from "./ChatProjectDetailView.vue?vue&type=script&lang=js"
export * from "./ChatProjectDetailView.vue?vue&type=script&lang=js"
import style0 from "./ChatProjectDetailView.vue?vue&type=style&index=0&id=ff31c408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff31c408",
  null
  
)

export default component.exports